module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point4_5-503e2ec13d0ec7d74318384a6e6c9481.jpg";